/* GOPSHOP 7.19 – Produktanfrage (sections/gop-wish-form.liquid): mehrere Produkte in einer Anfrage.
   1 Produkte: Karten (Marke/Modell, Variante, Menge, Budget je Produkt, Foto/Link) – „+ Weiteres Produkt“, Kopieren, Entfernen (mit
     Rückgängig), offene Karte klappt beim Hinzufügen zu einer Zeile zusammen; ab 2 Produkten Schalter „Lieber ein Gesamtbudget“.
   2 Zustand, Lieferung, „Wenn wir dein Budget bestätigen – wann zahlst du?“ (Pflicht).
   3 Kontakt: Vorname, E-Mail UND Handynummer (Pflicht; Ländervorwahl, Tippfehler-Hinweis bei der E-Mail, Kontroll-Anzeige),
     Übersicht, „Ich will direkt kaufen“ → Senden.
   Versand: POST an das Google Apps Script (action 'wish'). Alte Felder bleiben (name, email, phone, message, budget, condition, deadline,
   products[{what, variant, qty}], images, page, hp): „variant“ enthält bei Budget je Produkt auch „bis X €“, „message“ eine komplette
   Übersicht ab der Zeile „— Übersicht —“ – so kommt alles auch beim alten Script an. Neu: v, pay, payKey, bmode, total, ch, chKey,
   products[].v/.budget/.link/.photos (extras/gopa-sprint-apps-script.gs zeigt sie, wenn neu bereitgestellt).
   Entwurf (nur Text) in localStorage „gop-wish-v4“ (14 Tage; Entwurf v3 wird übernommen). Fotos: max. 4 je Anfrage, im Browser auf
   1600 px (JPEG) verkleinert. Vorbefüllen: Event „gop:wish-prefill“ {text|what, variant, budget, link, qty}, ?wish=…, sessionStorage
   „gop-wish-prefill“, window.gopWish.prefill(…) – füllt eine leere Karte, sonst kommt eine neue Karte dazu. */
(function () {
  'use strict';

  var MAX_IMG = 4;
  var MAX_BYTES = 15 * 1024 * 1024;
  var MAX_DIM = 1600;
  var QUALITY = 0.82;
  var TIMEOUT = 60000;
  var MAX_ITEMS = 10;
  var DRAFT_KEY = 'gop-wish-v4';
  var OLD_DRAFT_KEY = 'gop-wish-v3';
  var DRAFT_DAYS = 14;
  var PREFILL_KEY = 'gop-wish-prefill';
  var HIST_KEY = 'gop-wish-history';
  var HIST_MAX = 10;
  var MARK = '— Übersicht —';
  var CCS = ['49', '43', '41', '31', '32', '352', '33', '39', '34', '48', '420', '45', '46', '47', '44', '90', '971', '1'];
  var DOMAINS = ['gmail.com', 'googlemail.com', 'web.de', 'gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch', 'gmx.com', 't-online.de', 'yahoo.com', 'yahoo.de',
    'outlook.com', 'outlook.de', 'hotmail.com', 'hotmail.de', 'icloud.com', 'me.com', 'mac.com', 'live.com', 'live.de', 'msn.com', 'freenet.de',
    'aol.com', 'aol.de', 'mail.de', 'email.de', 'posteo.de', 'proton.me', 'protonmail.com', 'arcor.de', 'bluewin.ch', 'aon.at', 'online.de', 'vodafone.de'];
  var DOMAIN_FIX = { 'gmail.de': 'gmail.com', 'gmail.co': 'gmail.com', 'gmai.de': 'gmail.com', 'icloud.de': 'icloud.com', 'hotmail.co': 'hotmail.com', 'outlook.co': 'outlook.com', 'yahoo.co': 'yahoo.com' };

  var I18N = {
    de: {
      step: 'Schritt [n] von 3',
      steps: ['Produkte', 'Details', 'Kontakt'],
      next: 'Weiter',
      send: 'Anfrage senden',
      sending: 'Anfrage wird gesendet …',
      uploading: 'Bilder werden hochgeladen …',
      almost: 'Fast geschafft …',
      lWhat: 'Marke & Modell',
      phWhat: 'Marke & Modell',
      lVariant: 'Größe · Farbe · Variante',
      phVariant: '',
      optional: 'optional',
      qty: 'Menge',
      qtyLess: 'Menge verringern',
      qtyMore: 'Menge erhöhen',
      qtyHint: 'für alle [n] Stück zusammen',
      lBudget: 'Dein Budget',
      upTo: 'bis',
      max: 'max.',
      extPL: 'Foto oder Link',
      extL: 'Link',
      extHint: 'optional – hilft uns sehr',
      photoAdd: 'Foto / Screenshot',
      photoHint: 'max. 4 pro Anfrage',
      lLink: 'Produkt-Link',
      phLink: 'Link einfügen',
      productN: 'Produkt',
      products: 'Produkte',
      dup: 'Produkt kopieren',
      del: 'Produkt entfernen',
      missing: 'Angaben fehlen',
      added: '[x] hinzugefügt.',
      removed: '„[x]“ entfernt.',
      maxItems: 'Maximal 10 Produkte pro Anfrage.',
      addN: '[n] von 10',
      errWhat: 'Bitte nenne das Produkt – Marke und Modell reichen.',
      errWhatShort: 'Etwas genauer bitte – z. B. Marke und Modell.',
      errFake: 'Dazu können wir dir leider kein Angebot machen – bitte nenn ein konkretes Produkt mit Marke und Modell.',
      errLink: 'Dieser Link sieht nicht richtig aus.',
      errBudget: 'Bitte gib dein Budget an.',
      errTotal: 'Bitte gib dein Gesamtbudget an.',
      errBudgetMin: 'Bitte mindestens [n] € angeben.',
      errCond: 'Bitte wähle mindestens einen Zustand.',
      errPay: 'Bitte wähle, wann du zahlen würdest.',
      errName: 'Bitte gib deinen Vornamen ein.',
      errEmailEmpty: 'Bitte gib deine E-Mail-Adresse ein.',
      errEmail: 'Diese E-Mail-Adresse stimmt so nicht – bitte prüfen.',
      errPhoneEmpty: 'Bitte gib deine Handynummer ein.',
      errPhone: 'Diese Nummer stimmt so nicht – bitte prüfen.',
      errPhoneShort: 'Die Nummer ist zu kurz – fehlt eine Ziffer?',
      errPhoneLong: 'Die Nummer ist zu lang – bitte prüfen.',
      errBuy: 'Bitte bestätige, dass du direkt kaufen möchtest.',
      errBig: '„[name]“ ist zu groß (max. 15 MB).',
      errDecode: '„[name]“ kann dein Browser nicht öffnen. Bitte als JPG oder Screenshot hochladen.',
      errMax: 'Maximal 4 Bilder pro Anfrage.',
      errType: '„[name]“ ist keine Bilddatei.',
      busy: 'Bild wird vorbereitet …',
      remove: 'Bild entfernen',
      mailFix: 'Meintest du [x]?',
      mailFixBtn: 'Ja, übernehmen',
      telOk: 'So erreichen wir dich: [x]',
      edit: 'Ändern',
      sumTitle: 'Deine Anfrage',
      link: 'Link',
      photos: 'Fotos',
      photo: 'Foto',
      budget: 'Budget',
      total: 'Budget gesamt',
      totalSet: 'Gesamtbudget',
      condition: 'Zustand',
      delivery: 'Lieferung',
      pay: 'Zahlung',
      payAfter: 'Zahlung nach Bestätigung',
      prefCh: 'Antwort am liebsten per',
      reach: 'Hierhin schicken wir dein Angebot – bitte kurz prüfen:',
      confirmed: 'Bestätigt: will direkt kaufen und zahlt wie angegeben.',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Handy',
      note: 'Notiz',
      okTitle: 'Danke, [name]! Anfrage ist da.',
      okTitleNo: 'Danke! Anfrage ist da.',
      okText: 'Wir melden uns so schnell wie möglich.',
      okChPhone: 'per WhatsApp an [x].',
      okChCall: 'per Anruf oder WhatsApp an [x].',
      okChEmail: 'per E-Mail an [x].',
      copied: 'Kopiert',
      failTitle: 'Das hat nicht geklappt',
      failNoUrl: 'Fast fertig – per E-Mail senden',
      failNoUrlText: 'Öffne dein E-Mail-Programm – deine Anfrage ist schon eingetragen. Fotos bitte dort anhängen.',
      subject: 'Produktanfrage',
      intro: 'Hallo GOPSHOP, meine Anfrage:',
      ref: 'Anfrage-Nr.',
      photoNote: 'Fotos hänge ich an.',
      draft: 'Entwurf wiederhergestellt.',
      draftClear: 'Neu beginnen',
      copyNo: 'Nummer [x] kopieren',
      more: 'weitere'
    },
    en: {
      step: 'Step [n] of 3',
      steps: ['Products', 'Details', 'Contact'],
      next: 'Next',
      send: 'Send request',
      sending: 'Sending your request …',
      uploading: 'Uploading images …',
      almost: 'Almost done …',
      lWhat: 'Brand & model',
      phWhat: 'Brand & model',
      lVariant: 'Size · colour · variant',
      phVariant: '',
      optional: 'optional',
      qty: 'Qty',
      qtyLess: 'Decrease quantity',
      qtyMore: 'Increase quantity',
      qtyHint: 'for all [n] together',
      lBudget: 'Your budget',
      upTo: 'up to',
      max: 'max.',
      extPL: 'Photo or link',
      extL: 'Link',
      extHint: 'optional – helps a lot',
      photoAdd: 'Photo / screenshot',
      photoHint: 'up to 4 per request',
      lLink: 'Product link',
      phLink: 'Paste link',
      productN: 'Product',
      products: 'products',
      dup: 'Copy product',
      del: 'Remove product',
      missing: 'Details missing',
      added: '[x] added.',
      removed: '“[x]” removed.',
      maxItems: 'Up to 10 products per request.',
      addN: '[n] of 10',
      errWhat: 'Please name the product – brand and model are enough.',
      errWhatShort: 'A bit more precise please – e.g. brand and model.',
      errFake: 'We can\'t make an offer for that – please name a specific product with brand and model.',
      errLink: "This link doesn't look right.",
      errBudget: 'Please enter your budget.',
      errTotal: 'Please enter your total budget.',
      errBudgetMin: 'Please enter at least €[n].',
      errCond: 'Please choose at least one condition.',
      errPay: 'Please choose when you would pay.',
      errName: 'Please enter your first name.',
      errEmailEmpty: 'Please enter your email address.',
      errEmail: "This email address doesn't look right – please check.",
      errPhoneEmpty: 'Please enter your mobile number.',
      errPhone: "This number doesn't look right – please check.",
      errPhoneShort: 'The number is too short – a digit missing?',
      errPhoneLong: 'The number is too long – please check.',
      errBuy: 'Please confirm that you want to buy directly.',
      errBig: '“[name]” is too large (max. 15 MB).',
      errDecode: "Your browser can't open “[name]”. Please upload a JPG or a screenshot.",
      errMax: 'Up to 4 images per request.',
      errType: '“[name]” is not an image file.',
      busy: 'Preparing image …',
      remove: 'Remove image',
      mailFix: 'Did you mean [x]?',
      mailFixBtn: 'Yes, use it',
      telOk: 'We will reach you at: [x]',
      edit: 'Edit',
      sumTitle: 'Your request',
      link: 'Link',
      photos: 'photos',
      photo: 'photo',
      budget: 'Budget',
      total: 'Total budget',
      totalSet: 'Total budget',
      condition: 'Condition',
      delivery: 'Delivery',
      pay: 'Payment',
      payAfter: 'Payment after confirmation',
      prefCh: 'Preferred reply',
      reach: 'This is where we send your offer – please check:',
      confirmed: 'Confirmed: wants to buy directly and pays as stated.',
      name: 'Name',
      email: 'Email',
      phone: 'Mobile',
      note: 'Note',
      okTitle: 'Thanks, [name]! Request received.',
      okTitleNo: 'Thanks! Request received.',
      okText: "We'll get back to you as soon as possible.",
      okChPhone: 'via WhatsApp to [x].',
      okChCall: 'by call or WhatsApp to [x].',
      okChEmail: 'by email to [x].',
      copied: 'Copied',
      failTitle: "That didn't work",
      failNoUrl: 'Almost done – send by email',
      failNoUrlText: 'Open your email app – your request is already filled in. Please attach photos there.',
      subject: 'Product request',
      intro: 'Hello GOPSHOP, my request:',
      ref: 'Request no.',
      photoNote: "I'll attach photos.",
      draft: 'Draft restored.',
      draftClear: 'Start over',
      copyNo: 'Copy number [x]',
      more: 'more'
    }
  };

  var SVG = function (d, w) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (w || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  };
  var ICON = {
    chev: SVG('<path d="m6 9 6 6 6-6"/>'),
    dup: SVG('<rect x="8" y="8" width="12" height="12" rx="2.5"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>', 1.9),
    del: SVG('<path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/>', 1.9),
    minus: SVG('<path d="M5 12h14"/>', 2.4),
    plus: SVG('<path d="M12 5v14M5 12h14"/>', 2.4),
    cam: SVG('<rect x="3" y="6" width="18" height="14" rx="3"/><circle cx="12" cy="13" r="3.5"/><path d="M8.5 6 10 3.5h4L15.5 6"/>', 1.8),
    link: SVG('<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1"/><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1"/>', 1.9),
    x: SVG('<path d="M6 6l12 12M18 6 6 18"/>', 2.6),
    mail: SVG('<rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m4 7 8 6 8-6"/>', 1.9),
    tel: SVG('<rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18.5h2"/>', 1.9),
    ok: SVG('<path d="m5 12 5 5 9-10"/>', 2.8)
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(str, v) { return String(str).replace(/\[(name|n|x)\]/g, v); }
  function ls(fn) { try { return fn(window.localStorage); } catch (e) { return null; } }
  function ss(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  function num(v) { return parseInt(String(v == null ? '' : v).replace(/\D/g, ''), 10) || 0; }
  function clampQty(q) { return Math.min(20, Math.max(1, parseInt(q, 10) || 1)); }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function makeRef() {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var r = '';
    var rnd = new Uint8Array(4);
    (window.crypto || window.msCrypto).getRandomValues(rnd);
    for (var i = 0; i < 4; i++) r += abc[rnd[i] % abc.length];
    return 'GOP-' + p(d.getMonth() + 1) + p(d.getDate()) + '-' + r;
  }

  /* ---------- Bilder: dekodieren, verkleinern, JPEG ---------- */
  function decode(file) {
    var viaImg = function () {
      return new Promise(function (res, rej) {
        var url = URL.createObjectURL(file);
        var im = new Image();
        im.onload = function () { res({ src: im, w: im.naturalWidth, h: im.naturalHeight, done: function () { URL.revokeObjectURL(url); } }); };
        im.onerror = function () { URL.revokeObjectURL(url); rej(new Error('decode')); };
        im.src = url;
      });
    };
    if (window.createImageBitmap) {
      return createImageBitmap(file, { imageOrientation: 'from-image' })
        .then(function (b) { return { src: b, w: b.width, h: b.height, done: function () { if (b.close) b.close(); } }; })
        .catch(viaImg);
    }
    return viaImg();
  }

  function compress(file) {
    return decode(file).then(function (img) {
      if (!img.w || !img.h) throw new Error('decode');
      var s = Math.min(1, MAX_DIM / Math.max(img.w, img.h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(img.w * s));
      c.height = Math.max(1, Math.round(img.h * s));
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(img.src, 0, 0, c.width, c.height);
      img.done();
      return new Promise(function (res, rej) {
        c.toBlob(function (b) { if (b) res(b); else rej(new Error('encode')); }, 'image/jpeg', QUALITY);
      });
    }).then(function (blob) {
      return new Promise(function (res, rej) {
        var fr = new FileReader();
        fr.onload = function () { res({ blob: blob, data: String(fr.result).split(',')[1] }); };
        fr.onerror = rej;
        fr.readAsDataURL(blob);
      });
    });
  }

  function isImage(f) {
    return /^image\//.test(f.type) || /\.(heic|heif|jpe?g|png|webp|gif|avif)$/i.test(f.name || '');
  }

  /* 10.10.: Anfragen nach Nachbauten werden nicht angenommen (Muster window.gopFakeRx aus layout/theme.liquid) */
  function isFake(t) {
    var R = window.gopFakeRx;
    return !!(R && R.test && R.test(String(t || '')));
  }

  /* Vorbefüll-Daten vereinheitlichen: Text oder Objekt */
  function normPrefill(d) {
    if (d == null) return null;
    if (isFake(typeof d === 'string' ? d : (d.what || d.text || d.product || '') + ' ' + (d.variant || ''))) return null;
    if (typeof d === 'string') {
      var s = d.trim();
      if (s.charAt(0) === '{') { try { return normPrefill(JSON.parse(s)); } catch (e) { /* Text */ } }
      return s ? { what: s.slice(0, 120) } : null;
    }
    if (typeof d !== 'object') return null;
    var o = {
      what: String(d.what || d.text || d.product || '').replace(/­/g, '').trim().slice(0, 120),
      variant: String(d.variant || '').trim().slice(0, 120),
      link: String(d.link || d.url || '').trim().slice(0, 500),
      budget: num(d.budget),
      qty: parseInt(d.qty, 10) || 0
    };
    return o.what || o.variant || o.link || o.budget ? o : null;
  }

  /* ---------- Kontakt-Prüfhilfen ---------- */
  function mailOk(v) { return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[a-z]{2,}$/i.test(String(v || '')); }

  /* Levenshtein mit Vertauschung (gmial → gmail = 1) */
  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[m][n];
  }
  /* Tippfehler bei bekannten Anbietern → Vorschlag (gmial.con → gmail.com), sonst '' */
  function mailFix(v) {
    var m = /^([^@\s]+)@([^@\s]+)$/.exec(String(v || '').trim());
    if (!m) return '';
    var d = m[2].toLowerCase().replace(/\.+$/, '');
    if (DOMAINS.indexOf(d) >= 0) return '';
    var best = DOMAIN_FIX[d] || '';
    var bd = best ? 0 : 3;
    if (!best) {
      DOMAINS.forEach(function (x) {
        var k = lev(d, x);
        if (k < bd) { bd = k; best = x; }
      });
    }
    return best && bd <= 2 ? m[1] + '@' + best : '';
  }

  /* Nummer zerlegen: +49 / 0049 / 0152 … / 4915… → Ländervorwahl + Rufnummer ohne führende 0 */
  function parsePhone(raw, cc) {
    var s = String(raw || '').replace(/[^\d+]/g, '');
    var nsn;
    if (s.indexOf('00') === 0) s = '+' + s.slice(2);
    if (s.charAt(0) === '+') {
      var d = s.slice(1).replace(/\+/g, '');
      var hit = '';
      CCS.forEach(function (c) { if (d.indexOf(c) === 0 && c.length > hit.length) hit = c; });
      if (!hit) return { cc: '', nsn: d, raw: String(raw || '') };
      cc = hit;
      nsn = d.slice(hit.length);
    } else {
      nsn = s.replace(/\+/g, '');
      /* Ländervorwahl ohne „+“ vorne eingetippt (z. B. 4915…) */
      if (nsn.indexOf(cc) === 0 && nsn.length > (cc === '49' ? 11 : 12)) nsn = nsn.slice(cc.length);
    }
    return { cc: cc, nsn: nsn.replace(/^0+/, ''), raw: String(raw || '') };
  }
  function phoneErrKey(p) {
    if (!p.raw.trim()) return 'errPhoneEmpty';
    if (/[a-z]/i.test(p.raw) || !p.nsn || /^(\d)\1+$/.test(p.nsn)) return 'errPhone';
    var min = 6, max = 12;
    if (!p.cc) { min = 7; max = 14; }
    else if (p.cc === '49') { if (/^1[5-7]/.test(p.nsn)) { min = 10; max = 11; } else { max = 11; } }
    else if (p.cc === '43') { min = 7; max = 13; }
    else if (p.cc === '41') { min = 9; max = 9; }
    else if (p.cc === '44') { min = 9; max = 10; }
    else if (p.cc === '1') { min = 10; max = 10; }
    if (p.nsn.length < min) return 'errPhoneShort';
    if (p.nsn.length > max) return 'errPhoneLong';
    return '';
  }
  function groupNsn(n) { return n.length > 7 ? n.slice(0, 3) + ' ' + n.slice(3) : n; }
  function phoneFmt(p) { return p.cc ? '+' + p.cc + ' ' + groupNsn(p.nsn) : '+' + p.nsn; }

  function init(root) {
    if (!root || root.__gopWish) return;
    root.__gopWish = true;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var lang = root.dataset.lang === 'en' ? 'en' : 'de';
    var T = I18N[lang];
    var form = $('[data-w-form]');
    var endpoint = (root.dataset.endpoint || '').trim();
    var mailTo = (root.dataset.mail || '').trim();
    var bmin = Math.max(0, +root.dataset.bmin || 0);
    var photosOn = root.dataset.photos === '1';
    var okCustom = (root.dataset.okText || '').trim();
    var nf = new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'de-DE');
    var section = root.closest('.gop-wish') || root;
    var uid = Math.random().toString(36).slice(2, 7);

    var items = [];
    var itemSeq = 0;
    var images = [];
    var busy = 0;
    var seqNo = 0;
    var step = 1;
    var ref = '';
    var sending = false;
    var bmode = 'each';
    var undoBuf = null;
    var undoT = 0;

    var list = $('[data-w-items]');
    var addBtn = $('[data-w-add]');
    var addN = $('[data-w-add-n]');
    var bBox = $('[data-w-budget-box]');
    var bSwitch = $('[data-w-bmode]');
    var totEl = $('[data-w-tot]');
    var undoEl = $('[data-w-undo]');
    var live = $('[data-w-live]');
    var ccSel = $('[data-w-cc]');
    var telOk = $('[data-w-tel-ok]');
    var fixEl = $('[data-w-mail-fix]');

    function inp(k) { return $('[data-w-in="' + k + '"]'); }
    function val(k) { var el = inp(k); return el ? String(el.value || '').trim() : ''; }
    function field(k) { return $('[data-w-field="' + k + '"]'); }
    function radio(name) { return root.querySelector('input[name="' + name + '"]:checked'); }
    function money(n) { return lang === 'en' ? '€' + nf.format(n) : nf.format(n) + ' €'; }
    function upTo(n) { return T.upTo + ' ' + money(n); }
    function say(t) {
      if (!live) return;
      live.textContent = '';
      setTimeout(function () { live.textContent = t; }, 60);
    }
    function phone() { return parsePhone(inp('phone').value, ccSel ? ccSel.value : '49'); }

    /* ---------- Fehler ---------- */
    function setErr(k, msg) {
      var f = typeof k === 'string' ? field(k) : k;
      if (!f) return;
      var el = f.querySelector('.gw__err');
      var input = f.querySelector('input:not([type=checkbox]):not([type=radio]):not([type=file]), textarea') || f.querySelector('input');
      f.classList.toggle('is-invalid', !!msg);
      if (el) {
        el.textContent = msg || '';
        if (!el.id) el.id = 'GopWishErr' + Math.random().toString(36).slice(2, 8);
      }
      if (input) {
        if (msg) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
        if (el) {
          var d = (input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
          if (d.indexOf(el.id) < 0) { d.push(el.id); input.setAttribute('aria-describedby', d.join(' ')); }
        }
      }
    }
    function focusField(f) {
      if (!f) return;
      var em = f.querySelector('.gw__err');
      if (em && em.textContent) say(em.textContent);
      var x = f.querySelector('input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]), textarea') || f.querySelector('input');
      if (x) x.focus({ preventScroll: true });
      var r = f.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight - 120) f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      f.classList.remove('is-shake');
      void f.offsetWidth;
      f.classList.add('is-shake');
    }

    /* =====================================================================
       Produkte (Karten)
       ===================================================================== */
    function linkOk(v) { return !v || /^(https?:\/\/)?[^\s.\/]+\.[^\s]{2,}$/i.test(v); }
    function imgCount(it) { return images.filter(function (im) { return im.item === it.id; }).length; }
    function isEmpty(it) { return !it.what && !it.variant && !it.budget && !it.link && !imgCount(it); }

    function itemHTML(it) {
      var b = 'GopWI' + uid + it.id;
      return '' +
        '<div class="gw__item-h">' +
          '<button type="button" class="gw__item-tg" data-w-tg aria-expanded="false" aria-controls="' + b + 'B">' +
            '<span class="gw__item-n" data-w-no></span>' +
            '<span class="gw__item-tt"><strong data-w-tt></strong><small data-w-mt></small></span>' +
            '<span class="gw__item-chev">' + ICON.chev + '</span>' +
          '</button>' +
          '<button type="button" class="gw__ib" data-w-dup aria-label="' + esc(T.dup) + '" title="' + esc(T.dup) + '">' + ICON.dup + '</button>' +
          '<button type="button" class="gw__ib gw__ib--del" data-w-del aria-label="' + esc(T.del) + '" title="' + esc(T.del) + '">' + ICON.del + '</button>' +
        '</div>' +
        '<div class="gw__item-b" id="' + b + 'B">' +
          '<div class="gw__field" data-w-f="what">' +
            '<label for="' + b + 'W">' + esc(T.lWhat) + ' <span class="gw__req" aria-hidden="true">*</span></label>' +
            '<input type="text" id="' + b + 'W" class="gw__input gw__input--lg" data-w-k="what" maxlength="120" autocomplete="off" autocorrect="off" spellcheck="false" autocapitalize="sentences" enterkeyhint="next" aria-required="true" placeholder="' + esc(T.phWhat) + '">' +
            '<p class="gw__err"></p>' +
          '</div>' +
          '<div class="gw__row">' +
            '<div class="gw__field gw__field--grow" data-w-f="variant">' +
              '<label for="' + b + 'V">' + esc(T.lVariant) + ' <small>' + esc(T.optional) + '</small></label>' +
              '<input type="text" id="' + b + 'V" class="gw__input" data-w-k="variant" maxlength="120" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="next">' +
            '</div>' +
            '<div class="gw__field gw__field--qty">' +
              '<label for="' + b + 'Q">' + esc(T.qty) + '</label>' +
              '<div class="gw__stepper">' +
                '<button type="button" data-w-q="-1" aria-label="' + esc(T.qtyLess) + '">' + ICON.minus + '</button>' +
                '<input type="number" id="' + b + 'Q" data-w-k="qty" min="1" max="20" value="1" inputmode="numeric">' +
                '<button type="button" data-w-q="1" aria-label="' + esc(T.qtyMore) + '">' + ICON.plus + '</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="gw__field gw__ibudget" data-w-f="budget">' +
            '<label for="' + b + 'M">' + esc(T.lBudget) + ' <span class="gw__req" aria-hidden="true">*</span> <small data-w-qh></small></label>' +
            '<div class="gw__money gw__money--sm">' +
              '<span class="gw__money-pre" aria-hidden="true">' + esc(T.upTo) + '</span>' +
              '<input type="text" id="' + b + 'M" class="gw__money-in" data-w-k="budget" inputmode="numeric" pattern="[0-9.,]*" autocomplete="off" enterkeyhint="next" maxlength="7" placeholder="0" aria-required="true">' +
              '<span class="gw__money-cur" aria-hidden="true">€</span>' +
            '</div>' +
            '<p class="gw__err"></p>' +
          '</div>' +
          '<details class="gw__ext" data-w-ext>' +
            '<summary>' + ICON.plus + '<span>' + esc(photosOn ? T.extPL : T.extL) + '</span><small>' + esc(T.extHint) + '</small></summary>' +
            '<div class="gw__ref-grid">' +
              (photosOn
                ? '<label class="gw__drop" data-w-drop><input type="file" accept="image/*,.heic,.heif" multiple data-w-file>' +
                  '<span class="gw__drop-ic" aria-hidden="true">' + ICON.cam + '</span>' +
                  '<span class="gw__drop-t"><strong>' + esc(T.photoAdd) + '</strong><small>' + esc(T.photoHint) + '</small></span></label>'
                : '') +
              '<div class="gw__field gw__field--link" data-w-f="link">' +
                '<label class="gw__sr" for="' + b + 'L">' + esc(T.lLink) + '</label>' +
                '<span class="gw__link-ic" aria-hidden="true">' + ICON.link + '</span>' +
                '<input type="url" id="' + b + 'L" class="gw__input gw__input--link" data-w-k="link" maxlength="500" inputmode="url" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="' + esc(T.phLink) + '">' +
                '<p class="gw__err"></p>' +
              '</div>' +
            '</div>' +
            '<ul class="gw__thumbs" data-w-thumbs hidden></ul>' +
            '<p class="gw__err" data-w-img-err role="alert"></p>' +
          '</details>' +
        '</div>';
    }

    function mkItem(d) {
      d = d || {};
      var it = {
        id: ++itemSeq,
        what: String(d.what || '').trim().slice(0, 120),
        variant: String(d.variant || '').trim().slice(0, 120),
        qty: clampQty(d.qty),
        budget: Math.min(999999, num(d.budget)),
        link: String(d.link || '').trim().slice(0, 500),
        open: false,
        busy: 0
      };
      var li = document.createElement('li');
      li.className = 'gw__item';
      li.innerHTML = itemHTML(it);
      li.__it = it;
      it.el = li;
      it.$ = function (s) { return li.querySelector(s); };
      it.f = function (k) { return li.querySelector('[data-w-f="' + k + '"]'); };
      it.$('[data-w-k="what"]').value = it.what;
      it.$('[data-w-k="variant"]').value = it.variant;
      it.$('[data-w-k="qty"]').value = it.qty;
      it.$('[data-w-k="budget"]').value = it.budget ? nf.format(it.budget) : '';
      it.$('[data-w-k="link"]').value = it.link;
      if (it.link) it.$('[data-w-ext]').open = true;
      return it;
    }

    function metaText(it) {
      var a = [];
      if (it.variant) a.push(it.variant);
      if (it.qty > 1) a.push(it.qty + '×');
      if (bmode === 'each' && it.budget) a.push(upTo(it.budget));
      var ni = imgCount(it);
      if (ni) a.push(ni + ' ' + (ni === 1 ? T.photo : T.photos));
      else if (it.link) a.push(T.link);
      if (it.el.classList.contains('is-bad') && !it.open) a.unshift(T.missing);
      return a.join(' · ');
    }
    function paintHead(it) {
      var i = items.indexOf(it);
      var tt = it.$('[data-w-tt]');
      tt.textContent = it.what || T.productN + ' ' + (i + 1);
      tt.classList.toggle('is-ph', !it.what);
      it.$('[data-w-no]').textContent = i + 1;
      it.$('[data-w-mt]').textContent = metaText(it);
      it.$('[data-w-dup]').hidden = !it.what || items.length >= MAX_ITEMS;
    }
    function paint(it) {
      it.el.classList.toggle('is-open', !!it.open);
      it.$('[data-w-tg]').setAttribute('aria-expanded', it.open ? 'true' : 'false');
      it.$('.gw__item-b').hidden = !it.open;
      it.$('[data-w-del]').hidden = items.length < 2;
      it.f('budget').hidden = bmode === 'total';
      it.$('[data-w-qh]').textContent = it.qty > 1 && bmode === 'each' ? fill(T.qtyHint, it.qty) : '';
      paintHead(it);
    }
    function renderItems() {
      items.forEach(function (it) { list.appendChild(it.el); });
      Array.prototype.slice.call(list.children).forEach(function (li) { if (items.indexOf(li.__it) < 0) li.remove(); });
      if (items.length < 2 && bmode === 'total') setMode('each');
      items.forEach(paint);
      var n = items.length;
      addBtn.hidden = n >= MAX_ITEMS;
      addN.textContent = n > 1 ? fill(T.addN, n) : '';
      bBox.hidden = n < 2;
      root.classList.toggle('is-multi', n > 1);
      paintTotal();
    }
    function openItem(it, focusK) {
      items.forEach(function (x) { x.open = x === it; });
      items.forEach(paint);
      var r = it.el.getBoundingClientRect();
      if (r.top < 70 || r.top > window.innerHeight * 0.7) it.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (focusK) {
        var f = it.$('[data-w-k="' + focusK + '"]');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 40);
      }
    }
    function openFirst() {
      return items.filter(function (x) { return x.open; })[0] || items[0];
    }

    /* Prüfregeln je Karte */
    function itemErr(it, k) {
      if (k === 'what') {
        var v = it.what;
        return !v ? T.errWhat : isFake(v + ' ' + it.variant) ? T.errFake : v.replace(/[^\p{L}\p{N}]/gu, '').length < 3 ? T.errWhatShort : '';
      }
      if (k === 'link') return linkOk(it.link) ? '' : T.errLink;
      if (k === 'budget') {
        if (bmode === 'total') return '';
        return !it.budget ? T.errBudget : it.budget < bmin ? fill(T.errBudgetMin, nf.format(bmin)) : '';
      }
      return '';
    }
    /* → Schlüssel des ersten fehlerhaften Feldes oder '' */
    function checkItem(it, show) {
      var bad = '';
      ['what', 'budget', 'link'].forEach(function (k) {
        var m = itemErr(it, k);
        if (show) setErr(it.f(k), m);
        if (m && !bad) bad = k;
      });
      if (show) it.el.classList.toggle('is-bad', !!bad);
      return bad;
    }
    function focusItemErr(it, k) {
      openItem(it);
      if (k === 'link') it.$('[data-w-ext]').open = true;
      setTimeout(function () { focusField(it.f(k)); }, 30);
    }

    function addItem() {
      if (items.length >= MAX_ITEMS) { say(T.maxItems); return; }
      var last = items[items.length - 1];
      if (last && isEmpty(last)) { openItem(last, 'what'); return; }
      var cur = items.filter(function (x) { return x.open; })[0];
      if (cur) {
        var k = checkItem(cur, true);
        if (k) { focusItemErr(cur, k); return; }
      }
      var it = mkItem();
      items.push(it);
      items.forEach(function (x) { x.open = x === it; });
      renderItems();
      it.el.classList.add('is-new');
      setTimeout(function () { it.el.classList.remove('is-new'); }, 700);
      it.$('[data-w-k="what"]').focus({ preventScroll: true });
      it.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      say(fill(T.added, T.productN + ' ' + items.length));
      save();
    }
    function dupItem(it) {
      if (items.length >= MAX_ITEMS) { say(T.maxItems); return; }
      var c = mkItem({ what: it.what, qty: it.qty, budget: it.budget, link: it.link });
      items.splice(items.indexOf(it) + 1, 0, c);
      items.forEach(function (x) { x.open = x === c; });
      renderItems();
      c.el.classList.add('is-new');
      setTimeout(function () { c.el.classList.remove('is-new'); }, 700);
      c.$('[data-w-k="variant"]').focus({ preventScroll: true });
      say(fill(T.added, c.what));
      save();
    }
    function dropUndo() {
      clearTimeout(undoT);
      if (undoBuf) undoBuf.imgs.forEach(function (im) { URL.revokeObjectURL(im.url); });
      undoBuf = null;
      if (undoEl) undoEl.hidden = true;
    }
    function delItem(it) {
      if (items.length < 2) return;
      var idx = items.indexOf(it);
      var imgs = images.filter(function (im) { return im.item === it.id; });
      var empty = isEmpty(it);
      dropUndo();
      images = images.filter(function (im) { return im.item !== it.id; });
      items.splice(idx, 1);
      if (items.length === 1) items[0].open = true;
      renderItems();
      paintDrops();
      if (!empty && undoEl) {
        undoBuf = { it: it, idx: idx, imgs: imgs };
        undoEl.querySelector('[data-w-undo-t]').textContent = fill(T.removed, it.what || T.productN);
        undoEl.hidden = false;
        undoT = setTimeout(dropUndo, 8000);
      } else imgs.forEach(function (im) { URL.revokeObjectURL(im.url); });
      var nb = items[Math.min(idx, items.length - 1)];
      if (nb) nb.$('[data-w-tg]').focus({ preventScroll: true });
      save();
    }
    function undo() {
      if (!undoBuf) return;
      var u = undoBuf;
      undoBuf = null;
      clearTimeout(undoT);
      undoEl.hidden = true;
      if (items.length >= MAX_ITEMS) { u.imgs.forEach(function (im) { URL.revokeObjectURL(im.url); }); return; }
      items.splice(Math.min(u.idx, items.length), 0, u.it);
      u.imgs.forEach(function (im) {
        if (images.length + busy < MAX_IMG) images.push(im);
        else URL.revokeObjectURL(im.url);
      });
      images.sort(function (x, y) { return x.seq - y.seq; });
      renderItems();
      paintThumbs(u.it);
      paintDrops();
      u.it.$('[data-w-tg]').focus({ preventScroll: true });
      save();
    }
    if (undoEl) undoEl.querySelector('[data-w-undo-btn]').addEventListener('click', undo);
    addBtn.addEventListener('click', addItem);

    /* Geldbetrag beim Tippen formatieren (1.500) */
    function fmtMoney(el, maxDigits) {
      var digits = el.value.replace(/\D/g, '').slice(0, maxDigits);
      var f = digits ? nf.format(parseInt(digits, 10)) : '';
      if (f !== el.value) {
        el.value = f;
        try { el.setSelectionRange(f.length, f.length); } catch (er) { /* */ }
      }
      return digits ? parseInt(digits, 10) : 0;
    }

    list.addEventListener('input', function (e) {
      var li = e.target.closest('.gw__item');
      var k = e.target.getAttribute('data-w-k');
      if (!li || !k) return;
      var it = li.__it;
      if (k === 'budget') { it.budget = fmtMoney(e.target, 6); paintTotal(); }
      else if (k === 'qty') it.qty = clampQty(e.target.value);
      else it[k] = String(e.target.value || '').trim();
      var f = it.f(k);
      if (f && f.classList.contains('is-invalid')) setErr(f, itemErr(it, k));
      if (li.classList.contains('is-bad') && !checkItem(it, false)) li.classList.remove('is-bad');
      if (k === 'qty') paint(it);
      else paintHead(it);
    });
    list.addEventListener('focusout', function (e) {
      var li = e.target.closest('.gw__item');
      var k = e.target.getAttribute('data-w-k');
      if (!li || !k) return;
      var it = li.__it;
      if (k === 'link') {
        var v = e.target.value.trim();
        if (v && !/^https?:\/\//i.test(v) && /\./.test(v)) { e.target.value = 'https://' + v; it.link = e.target.value; }
      }
      if (k === 'qty') { e.target.value = it.qty; return; }
      if ((k === 'what' || k === 'link' || k === 'budget') && e.target.value) setErr(it.f(k), itemErr(it, k));
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.gw__item');
      if (!li) return;
      var it = li.__it;
      var q = e.target.closest('[data-w-q]');
      if (q) {
        it.qty = clampQty(it.qty + +q.getAttribute('data-w-q'));
        it.$('[data-w-k="qty"]').value = it.qty;
        paint(it);
        save();
        return;
      }
      if (e.target.closest('[data-w-tg]')) {
        if (it.open && items.length > 1) { it.open = false; paint(it); }
        else openItem(it, it.what ? '' : 'what');
        return;
      }
      if (e.target.closest('[data-w-dup]')) { dupItem(it); return; }
      if (e.target.closest('[data-w-del]')) { delItem(it); return; }
      var rm = e.target.closest('[data-w-rmimg]');
      if (rm) {
        var seq = +rm.getAttribute('data-w-rmimg');
        images = images.filter(function (im) {
          if (im.seq !== seq) return true;
          URL.revokeObjectURL(im.url);
          return false;
        });
        showImgErr(it, []);
        paintThumbs(it);
        paintDrops();
        paintHead(it);
        return;
      }
      var mo = e.target.closest('.gw__money');
      if (mo && e.target.tagName !== 'INPUT') mo.querySelector('input').focus();
    });
    list.addEventListener('change', function (e) {
      var li = e.target.closest('.gw__item');
      if (!li) return;
      if (e.target.matches('[data-w-file]')) { addFiles(li.__it, e.target.files); e.target.value = ''; }
    });

    /* ---------- Fotos (je Produkt, zusammen max. 4) ---------- */
    function showImgErr(it, errs) { var el = it.$('[data-w-img-err]'); if (el) el.textContent = errs.join(' '); }
    function paintThumbs(it) {
      var ul = it.$('[data-w-thumbs]');
      if (!ul) return;
      var mine = images.filter(function (im) { return im.item === it.id; });
      var h = mine.map(function (im, i) {
        return '<li class="gw__thumb"><img src="' + im.url + '" alt="' + esc(im.label) + '" width="72" height="72"><button type="button" aria-label="' + esc(T.remove + ' ' + (i + 1)) + '" data-w-rmimg="' + im.seq + '">' + ICON.x + '</button></li>';
      }).join('');
      for (var b = 0; b < it.busy; b++) h += '<li class="gw__thumb is-busy"><span class="gw__spin"></span><span class="gw__sr">' + esc(T.busy) + '</span></li>';
      ul.innerHTML = h;
      ul.hidden = !mine.length && !it.busy;
    }
    function paintDrops() {
      var full = images.length + busy >= MAX_IMG;
      $$('[data-w-drop]').forEach(function (d) {
        d.classList.toggle('is-full', full);
        var fi = d.querySelector('input');
        if (fi) fi.disabled = full;
      });
    }
    function addFiles(it, fileList) {
      if (!photosOn || !it) return;
      var errs = [];
      it.$('[data-w-ext]').open = true;
      Array.prototype.slice.call(fileList || []).forEach(function (f) {
        if (!isImage(f)) { errs.push(fill(T.errType, f.name || 'Datei')); return; }
        if (f.size > MAX_BYTES) { errs.push(fill(T.errBig, f.name)); return; }
        if (images.length + busy >= MAX_IMG) { if (errs.indexOf(T.errMax) < 0) errs.push(T.errMax); return; }
        busy++;
        it.busy++;
        var seq = ++seqNo;
        compress(f).then(function (r) {
          var base = (f.name || 'bild').replace(/\.[^.]+$/, '').replace(/[^\w\-]+/g, '_').slice(0, 40) || 'bild';
          if (items.indexOf(it) < 0) return; /* Karte inzwischen entfernt */
          images.push({ seq: seq, item: it.id, name: base + '.jpg', label: f.name || base, data: r.data, blob: r.blob, url: URL.createObjectURL(r.blob) });
          images.sort(function (x, y) { return x.seq - y.seq; });
        }).catch(function () {
          showImgErr(it, [fill(T.errDecode, f.name || 'Bild')]);
        }).then(function () {
          busy--;
          it.busy--;
          paintThumbs(it);
          paintDrops();
          paintHead(it);
        });
      });
      paintThumbs(it);
      paintDrops();
      showImgErr(it, errs);
    }
    ['dragenter', 'dragover'].forEach(function (ev) {
      list.addEventListener(ev, function (e) {
        var d = e.target.closest && e.target.closest('[data-w-drop]');
        if (!d) return;
        e.preventDefault();
        d.classList.add('is-over');
      });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      list.addEventListener(ev, function (e) {
        var d = e.target.closest && e.target.closest('[data-w-drop]');
        if (!d) return;
        e.preventDefault();
        d.classList.remove('is-over');
        if (ev === 'drop' && e.dataTransfer) addFiles(d.closest('.gw__item').__it, e.dataTransfer.files);
      });
    });
    if (photosOn) {
      document.addEventListener('paste', function (e) {
        if (step !== 1 || !e.clipboardData) return;
        var r = root.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var files = [];
        Array.prototype.forEach.call(e.clipboardData.items || [], function (x) {
          if (x.kind === 'file') { var f = x.getAsFile(); if (f) files.push(f); }
        });
        if (files.length) { e.preventDefault(); addFiles(openFirst(), files); }
      });
    }

    /* ---------- Budget je Produkt oder gesamt ---------- */
    var totIn = inp('total');
    var chips = $$('[data-w-b]');
    chips.forEach(function (c) { c.textContent = money(+c.dataset.wB); });
    function syncChips() {
      var b = num(totIn.value);
      chips.forEach(function (c) {
        var on = +c.dataset.wB === b;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function sumBudgets() { return items.reduce(function (s, it) { return s + (it.budget || 0); }, 0); }
    function totalBudget() { return bmode === 'total' ? num(totIn.value) : sumBudgets(); }
    function paintTotal() {
      if (!totEl) return;
      var t = totalBudget();
      totEl.innerHTML = items.length < 2 ? '' :
        '<span>' + esc(items.length + ' ' + T.products) + '</span>' + (t ? '<strong>' + esc((bmode === 'total' ? T.totalSet : T.total) + ' ' + upTo(t)) + '</strong>' : '');
    }
    function setMode(m) {
      bmode = m === 'total' && items.length > 1 ? 'total' : 'each';
      bSwitch.checked = bmode === 'total';
      field('total').hidden = bmode !== 'total';
      if (bmode === 'total') {
        if (!num(totIn.value) && sumBudgets()) { totIn.value = nf.format(sumBudgets()); syncChips(); }
        items.forEach(function (it) { setErr(it.f('budget'), ''); });
      } else setErr('total', '');
      items.forEach(function (it) {
        if (it.el.classList.contains('is-bad') && !checkItem(it, false)) it.el.classList.remove('is-bad');
        paint(it);
      });
      paintTotal();
    }
    bSwitch.addEventListener('change', function () {
      setMode(bSwitch.checked ? 'total' : 'each');
      if (bmode === 'total' && !num(totIn.value)) totIn.focus({ preventScroll: true });
      save();
    });
    totIn.addEventListener('input', function () {
      fmtMoney(totIn, 7);
      syncChips();
      paintTotal();
      if (field('total').classList.contains('is-invalid')) check('total');
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        totIn.value = nf.format(+c.dataset.wB);
        syncChips();
        paintTotal();
        if (field('total').classList.contains('is-invalid')) check('total');
        save();
      });
    });
    field('total').querySelector('.gw__money').addEventListener('click', function (e) { if (e.target !== totIn) totIn.focus(); });

    /* ---------- Kontakt: E-Mail-Tippfehler, Nummer mit Ländervorwahl ---------- */
    function paintFix() {
      if (!fixEl) return;
      var s = mailFix(val('email'));
      fixEl.__s = s;
      fixEl.hidden = !s;
      if (s) fixEl.innerHTML = '<span>' + esc(fill(T.mailFix, s)) + '</span><button type="button" class="gw__link" data-w-fix-yes>' + esc(T.mailFixBtn) + '</button>';
    }
    inp('email').addEventListener('blur', paintFix);
    inp('email').addEventListener('input', function () { if (fixEl && !fixEl.hidden) paintFix(); });
    if (fixEl) fixEl.addEventListener('click', function (e) {
      if (!e.target.closest('[data-w-fix-yes]') || !fixEl.__s) return;
      inp('email').value = fixEl.__s;
      fixEl.hidden = true;
      check('email');
      renderSum();
      save();
      inp('phone').focus({ preventScroll: true });
    });
    function paintPhone() {
      var p = phone();
      if (p.cc && ccSel && ccSel.value !== p.cc && ccSel.querySelector('option[value="' + p.cc + '"]')) ccSel.value = p.cc;
      var ok = !phoneErrKey(p);
      if (telOk) {
        telOk.hidden = !ok;
        if (ok) telOk.innerHTML = ICON.ok + '<span>' + esc(fill(T.telOk, phoneFmt(p))) + '</span>';
      }
    }
    inp('phone').addEventListener('input', paintPhone);
    inp('phone').addEventListener('blur', function () {
      var el = inp('phone');
      if (!/^\s*(\+|00)/.test(el.value)) return;
      var p = phone();
      if (p.cc && !phoneErrKey(p)) { el.value = groupNsn(p.nsn); paintPhone(); }
    });
    if (ccSel) ccSel.addEventListener('change', function () {
      paintPhone();
      if (field('phone').classList.contains('is-invalid') || val('phone')) check('phone');
      renderSum();
      save();
    });

    /* ---------- Prüfregeln (Schritt 2 + 3) ---------- */
    function conds() { return $$('input[name="gw-cond"]:checked'); }
    var RULES = {
      total: function () {
        if (bmode !== 'total') return '';
        var b = num(totIn.value);
        return !b ? T.errTotal : b < bmin ? fill(T.errBudgetMin, nf.format(bmin)) : '';
      },
      cond: function () { return conds().length ? '' : T.errCond; },
      pay: function () { return radio('gw-pay') ? '' : T.errPay; },
      name: function () { return val('name') ? '' : T.errName; },
      email: function () { var v = val('email'); return !v ? T.errEmailEmpty : mailOk(v) ? '' : T.errEmail; },
      phone: function () { var k = phoneErrKey(phone()); return k ? T[k] : ''; },
      buy: function () { return $('[data-w-buy]').checked ? '' : T.errBuy; }
    };
    var STEP_RULES = { 2: ['cond', 'pay'], 3: ['name', 'email', 'phone', 'buy'] };
    function check(k) { var m = RULES[k](); setErr(k, m); return !m; }

    function validate1() {
      /* leere Zusatz-Karten still entfernen */
      if (items.length > 1) {
        var empty = items.filter(isEmpty);
        if (empty.length && empty.length < items.length) {
          items = items.filter(function (x) { return !isEmpty(x); });
          if (items.length === 1) items[0].open = true;
          renderItems();
        }
      }
      var bad = null;
      var badK = '';
      items.forEach(function (it) {
        var k = checkItem(it, true);
        if (k && !bad) { bad = it; badK = k; }
        paintHead(it);
      });
      if (bad) { focusItemErr(bad, badK); return false; }
      if (!check('total')) { focusField(field('total')); return false; }
      return true;
    }
    function validate(s) {
      if (s === 1) return validate1();
      var bad = null;
      STEP_RULES[s].forEach(function (k) { if (!check(k) && !bad) bad = field(k); });
      if (bad) { focusField(bad); return false; }
      return true;
    }
    /* Live-Prüfung: Fehler verschwinden beim Tippen, neue erst nach Verlassen des Feldes */
    root.addEventListener('input', function (e) {
      var f = e.target.closest('[data-w-field]');
      if (f && f.classList.contains('is-invalid') && RULES[f.dataset.wField]) check(f.dataset.wField);
      if (step === 3 && /^(name|email|phone)$/.test(e.target.getAttribute('data-w-in') || '')) renderSum();
    });
    root.addEventListener('focusout', function (e) {
      var f = e.target.closest('[data-w-field]');
      if (!f || !RULES[f.dataset.wField] || /buy|cond|pay|total/.test(f.dataset.wField)) return;
      if (!e.target.value) return;
      check(f.dataset.wField);
    });
    root.addEventListener('change', function (e) {
      var f = e.target.closest('[data-w-field]');
      if (f && f.classList.contains('is-invalid') && RULES[f.dataset.wField]) check(f.dataset.wField);
    });

    /* ---------- Texte für Übersicht, Nachricht, Server ---------- */
    function condText() { return conds().map(function (c) { return c.dataset.label; }).join(', '); }
    function dlText() { var r = radio('gw-dl'); return r ? r.dataset.label : ''; }
    function dlShort() { var r = radio('gw-dl'); var t = r && r.closest('label').querySelector('.gw__opt-t'); return t ? t.textContent.trim() : ''; }
    function payLabel() { var r = radio('gw-pay'); return r ? r.dataset.label : ''; }
    function chKey() { var r = radio('gw-ch'); return r ? r.value : 'wa'; }
    function chLabel() { var r = radio('gw-ch'); return r ? r.dataset.label : 'WhatsApp'; }
    function itemLine(it, i) {
      var a = [(i + 1) + ') ' + it.what];
      if (it.variant) a.push(it.variant);
      a.push(it.qty + '×');
      if (bmode === 'each' && it.budget) a.push(upTo(it.budget));
      var ni = imgCount(it);
      if (ni) a.push(ni + ' ' + (ni === 1 ? T.photo : T.photos));
      if (it.link) a.push(it.link);
      return a.join(' · ');
    }
    /* 7.21 Halloween: Rabatt automatisch mitschicken, solange der Look aktiv ist (window.gopHW aus theme.liquid) */
    function hwDeal() {
      var H = window.gopHW;
      return H && H.code && document.documentElement.classList.contains('gop-hw') ? H : null;
    }
    function overview() {
      var L = [MARK];
      var hw = hwDeal();
      if (hw) L.push((lang === 'en' ? 'Halloween discount: −' : 'Halloween-Rabatt: −') + hw.pct + ' % (Code ' + hw.code + ')');
      items.forEach(function (it, i) { L.push(itemLine(it, i)); });
      var t = totalBudget();
      if (t) L.push((bmode === 'total' ? T.totalSet : T.total) + ': ' + upTo(t));
      L.push(T.payAfter + ': ' + payLabel());
      L.push(T.condition + ': ' + condText());
      L.push(T.delivery + ': ' + dlText());
      L.push(T.prefCh + ': ' + chLabel());
      L.push(T.confirmed);
      return L.join('\n');
    }
    function messageText() { return (val('message') ? val('message') + '\n\n' : '') + overview(); }
    function summaryText() {
      var L = [T.intro, T.ref + ' ' + ref, ''];
      L.push(overview().replace(MARK + '\n', ''));
      if (val('message')) L.push('', T.note + ': ' + val('message'));
      L.push('', T.name + ': ' + val('name'));
      L.push(T.email + ': ' + val('email'));
      L.push(T.phone + ': ' + phoneFmt(phone()));
      if (images.length) L.push('', T.photoNote + ' (' + images.length + ')');
      return L.join('\n');
    }
    function mailUrl() {
      var first = items[0] ? items[0].what : '';
      return 'mailto:' + encodeURIComponent(mailTo).replace('%40', '@') + '?subject=' + encodeURIComponent(T.subject + ' ' + ref + ' – ' + first.slice(0, 50) + (items.length > 1 ? ' + ' + (items.length - 1) : '')) + '&body=' + encodeURIComponent(summaryText());
    }

    /* ---------- Übersicht (Schritt 3) ---------- */
    var sumEl = $('[data-w-sum]');
    var sumRaf = 0;
    function renderSum() {
      if (!sumEl || step !== 3) return;
      if (sumRaf) return;
      sumRaf = requestAnimationFrame(function () {
        sumRaf = 0;
        var t = totalBudget();
        var rows = items.map(function (it, i) {
          var ni = imgCount(it);
          var sub = [it.variant, it.qty > 1 ? it.qty + '×' : '', ni ? ni + ' ' + (ni === 1 ? T.photo : T.photos) : '', it.link ? T.link : ''].filter(Boolean).join(' · ');
          return '<li><span class="gw__sum-n">' + (i + 1) + '</span><span class="gw__sum-t"><strong>' + esc(it.what) + '</strong>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span>' +
            (bmode === 'each' && it.budget ? '<span class="gw__sum-b">' + esc(upTo(it.budget)) + '</span>' : '') + '</li>';
        }).join('');
        var p = phone();
        var telGood = !phoneErrKey(p);
        var mailGood = mailOk(val('email'));
        sumEl.innerHTML =
          '<div class="gw__sum-h"><p>' + esc(T.sumTitle) + '</p><button type="button" class="gw__link" data-w-edit="1" aria-label="' + esc(T.edit + ': ' + T.products) + '">' + esc(T.edit) + '</button></div>' +
          '<ol class="gw__sum-items">' + rows + '</ol>' +
          (t ? '<div class="gw__sum-tot"><span>' + esc(bmode === 'total' ? T.totalSet : items.length > 1 ? T.total : T.budget) + '</span><strong>' + esc(upTo(t)) + '</strong></div>' : '') +
          '<div class="gw__sum-facts"><dl>' +
            '<div><dt>' + esc(T.condition) + '</dt><dd>' + esc(condText()) + '</dd></div>' +
            '<div><dt>' + esc(T.delivery) + '</dt><dd>' + esc(dlShort()) + '</dd></div>' +
            '<div class="is-pay"><dt>' + esc(T.pay) + '</dt><dd>' + esc(payLabel()) + '</dd></div>' +
          '</dl><button type="button" class="gw__link" data-w-edit="2" aria-label="' + esc(T.edit + ': ' + T.pay) + '">' + esc(T.edit) + '</button></div>' +
          '<div class="gw__sum-reach"><p>' + esc(T.reach) + '</p><ul>' +
            '<li class="' + (mailGood ? 'is-ok' : '') + '">' + ICON.mail + '<span>' + esc(val('email') || '–') + '</span>' + (mailGood ? ICON.ok : '') + '</li>' +
            '<li class="' + (telGood ? 'is-ok' : '') + '">' + ICON.tel + '<span>' + esc(telGood ? phoneFmt(p) : val('phone') || '–') + '</span>' + (telGood ? ICON.ok : '') + '</li>' +
          '</ul></div>';
      });
    }
    if (sumEl) sumEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-w-edit]');
      if (b) show(+b.dataset.wEdit, -1);
    });

    /* ---------- Schritte ---------- */
    var panels = {};
    $$('[data-w-panel]').forEach(function (p) { panels[p.dataset.wPanel] = p; });
    var nextBtn = $('[data-w-next]');
    var nextLabel = $('[data-w-next-label]');
    var backBtn = $('[data-w-back]');
    var actions = $('[data-w-actions]');
    var countEl = $('[data-w-count]');
    var dots = $$('[data-w-dot]');

    function show(id, dir, quiet) {
      var prev = String(step);
      Object.keys(panels).forEach(function (k) {
        var p = panels[k];
        var on = k === String(id);
        p.hidden = !on;
        p.classList.remove('is-fwd', 'is-back');
        if (on && k !== prev && !quiet) { void p.offsetWidth; p.classList.add(dir < 0 ? 'is-back' : 'is-fwd'); }
      });
      step = id;
      root.dataset.step = id;
      var n = typeof id === 'number' ? id : 4;
      dots.forEach(function (d) {
        var i = +d.dataset.wDot;
        d.classList.toggle('is-done', i < n);
        d.classList.toggle('is-active', i === n);
      });
      if (countEl) countEl.textContent = Math.min(3, n);
      var terminal = id === 'ok' || id === 'fail';
      actions.hidden = terminal;
      root.classList.toggle('is-terminal', terminal);
      backBtn.hidden = n === 1 || terminal;
      nextLabel.textContent = n === 3 ? T.send : T.next;
      nextBtn.classList.toggle('is-send', n === 3);
      if (n <= 3) live.textContent = fill(T.step, n) + ': ' + T.steps[n - 1];
      if (id === 3) { paintPhone(); renderSum(); }
      document.dispatchEvent(new CustomEvent('gop:wish-step', { detail: { step: id } }));
      if (quiet) return;
      var r = form.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) {
        form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      var title = panels[id].querySelector('.gw__title');
      if (title) title.focus({ preventScroll: true });
    }
    function next() {
      if (sending || typeof step !== 'number') return;
      if (!validate(step)) return;
      if (step < 3) {
        if (step === 1) items.forEach(function (x) { x.open = false; });
        show(step + 1, 1);
        if (step === 2) items.forEach(paint);
        save();
        return;
      }
      post();
    }
    function back() {
      if (sending) return;
      if (step === 'fail') show(3, -1);
      else if (step > 1) {
        show(step - 1, -1);
        if (step === 1 && items.length === 1) { items[0].open = true; paint(items[0]); }
      }
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); next(); });
    backBtn.addEventListener('click', back);
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'SELECT' || t.tagName === 'SUMMARY' || t.type === 'checkbox' || t.type === 'radio' || t.type === 'file') return;
      e.preventDefault();
      /* Enter: in der Karte zum nächsten Feld, im Kontakt zum nächsten Feld, sonst Weiter */
      var li = t.closest('.gw__item');
      if (li) {
        var order = ['what', 'variant'].concat(bmode === 'each' ? ['budget'] : []);
        var i = order.indexOf(t.getAttribute('data-w-k'));
        if (i >= 0 && i < order.length - 1) { li.querySelector('[data-w-k="' + order[i + 1] + '"]').focus(); return; }
      }
      if (t === inp('name')) { inp('email').focus(); return; }
      if (t === inp('email')) { inp('phone').focus(); return; }
      next();
    });

    /* ---------- Senden ---------- */
    var sendingBox = $('[data-w-sending]');
    var sendBar = $('[data-w-sendbar]');
    var sendText = $('[data-w-sendtext]');
    var timer = null;
    function setSending(on) {
      sending = on;
      root.classList.toggle('is-sending', on);
      sendingBox.hidden = !on;
      nextBtn.disabled = on;
      backBtn.disabled = on;
      clearInterval(timer);
      if (!on) return;
      var t0 = Date.now();
      var hasImg = images.length > 0;
      var tick = function () {
        var s = (Date.now() - t0) / 1000;
        var p = 92 * (1 - Math.exp(-s / (hasImg ? 6 : 2.5)));
        sendBar.style.transform = 'scaleX(' + (0.04 + p / 100) + ')';
        sendText.textContent = p > 70 ? T.almost : hasImg ? T.uploading : T.sending;
      };
      tick();
      timer = setInterval(tick, 250);
    }

    function okProdText() {
      var t = totalBudget();
      if (items.length > 1) return items.length + ' ' + T.products + (t ? ' · ' + upTo(t) : '');
      var it = items[0];
      return it.what + (it.variant ? ' · ' + it.variant : '') + (t ? ' · ' + upTo(t) : '');
    }
    function success(id) {
      if (id) ref = String(id);
      $('[data-w-ref]').textContent = ref;
      var nm = val('name').split(/\s+/)[0];
      $('[data-w-ok-title]').textContent = nm ? fill(T.okTitle, nm) : T.okTitleNo;
      $('[data-w-ok-text]').textContent = okCustom ? fill(okCustom, nm) : T.okText;
      var op = $('[data-w-ok-prod]');
      if (op) op.textContent = okProdText();
      var ch = chKey();
      $('[data-w-ok-ch]').textContent = ch === 'email' ? fill(T.okChEmail, val('email')) : fill(ch === 'call' ? T.okChCall : T.okChPhone, phoneFmt(phone()));
      ls(function (s) { s.removeItem(DRAFT_KEY); });
      remember();
      show('ok', 1);
      document.dispatchEvent(new CustomEvent('gop:wish-sent', { detail: { id: ref, channel: 'form', items: items.length } }));
    }

    /* ---------- Deine letzten Anfragen (nur lokal, nur Text: Nummer, Produkt, Variante, Budget, Datum) ---------- */
    var mine = $('[data-w-mine]');
    var mineList = $('[data-w-mine-list]');
    var copySvg = ICON.dup;
    function pastList() {
      var h = null;
      try { h = JSON.parse(ls(function (s) { return s.getItem(HIST_KEY); }) || '[]'); } catch (e) { h = []; }
      return Array.isArray(h) ? h.filter(function (x) { return x && x.id; }).slice(0, HIST_MAX) : [];
    }
    function remember() {
      var h = pastList().filter(function (x) { return x.id !== ref; });
      var first = items[0] || { what: '', variant: '' };
      h.unshift({
        id: ref,
        what: (first.what + (items.length > 1 ? ' + ' + (items.length - 1) + ' ' + T.more : '')).slice(0, 140),
        variant: items.length > 1 ? '' : first.variant.slice(0, 120),
        budget: totalBudget(),
        t: Date.now()
      });
      ls(function (s) { s.setItem(HIST_KEY, JSON.stringify(h.slice(0, HIST_MAX))); });
      renderMine();
    }
    function renderMine() {
      if (!mine) return;
      var h = pastList();
      mine.hidden = !h.length;
      if (!h.length) { mine.open = false; return; }
      $('[data-w-mine-n]').textContent = h.length;
      var df = new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : 'de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
      mineList.innerHTML = h.map(function (x) {
        var meta = [x.variant, x.budget ? upTo(x.budget) : '', x.t ? df.format(new Date(x.t)) : ''].filter(Boolean).join(' · ');
        return '<li><div class="gw__mine-t"><strong>' + esc(x.what || '–') + '</strong>' + (meta ? '<small>' + esc(meta) + '</small>' : '') + '</div>' +
          '<button type="button" class="gw__mine-no" data-w-mine-copy="' + esc(x.id) + '" aria-label="' + esc(fill(T.copyNo, x.id)) + '">' + copySvg + '<span>' + esc(x.id) + '</span></button></li>';
      }).join('');
    }
    if (mine) {
      mineList.addEventListener('click', function (e) {
        var b = e.target.closest('[data-w-mine-copy]');
        if (!b || !navigator.clipboard) return;
        var id = b.getAttribute('data-w-mine-copy');
        navigator.clipboard.writeText(id).then(function () {
          var sp = b.querySelector('span');
          sp.textContent = T.copied;
          b.classList.add('is-ok');
          setTimeout(function () { sp.textContent = id; b.classList.remove('is-ok'); }, 1500);
        }, function () { /* */ });
      });
      $('[data-w-mine-clear]').addEventListener('click', function () {
        ls(function (s) { s.removeItem(HIST_KEY); });
        renderMine();
      });
      renderMine();
    }

    function fail(noUrl) {
      $('[data-w-fail-title]').textContent = noUrl ? T.failNoUrl : T.failTitle;
      if (noUrl) $('[data-w-fail-text]').textContent = T.failNoUrlText;
      var retry = $('[data-w-retry]');
      if (retry) retry.hidden = noUrl;
      var fb = $('[data-w-fb-mail]');
      if (fb) {
        fb.href = mailUrl();
        fb.classList.toggle('gop-btn--primary', noUrl);
        fb.classList.toggle('gop-btn--ghost', !noUrl);
      }
      show('fail', 1);
    }

    function post() {
      if (sending) return;
      if (busy) { setTimeout(post, 300); return; }
      if (!ref) ref = makeRef();
      if (!endpoint) { fail(true); return; }
      var t = totalBudget();
      var order = items.map(function (it) { return it.id; });
      var imgs = images.slice().sort(function (x, y) { return order.indexOf(x.item) - order.indexOf(y.item) || x.seq - y.seq; });
      var payload = {
        action: 'wish',
        v: 2,
        id: ref,
        lang: lang,
        name: val('name'),
        email: val('email'),
        phone: phoneFmt(phone()),
        message: messageText(),
        budget: t ? T.max + ' ' + nf.format(t) : '',
        bmode: bmode,
        total: t,
        condition: condText(),
        deadline: dlText(),
        pay: payLabel(),
        payKey: (radio('gw-pay') || {}).value || '',
        ch: chLabel(),
        chKey: chKey(),
        code: hwDeal() ? hwDeal().code : '',
        discount: hwDeal() ? hwDeal().pct : 0,
        products: items.map(function (it) {
          return {
            what: it.what,
            variant: [it.variant, bmode === 'each' && it.budget ? upTo(it.budget) : ''].filter(Boolean).join(' · '),
            qty: it.qty,
            v: it.variant,
            budget: bmode === 'each' ? it.budget : 0,
            link: it.link,
            photos: imgCount(it)
          };
        }),
        images: imgs.map(function (im) { return { name: im.name, type: 'image/jpeg', data: im.data }; }),
        page: location.href.split('#')[0],
        hp: ($('[data-w-hp]') || {}).value || ''
      };
      var ctrl = window.AbortController ? new AbortController() : null;
      var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
      setSending(true);
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        signal: ctrl ? ctrl.signal : undefined,
        redirect: 'follow'
      })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error((j && j.error) || 'failed');
          sendBar.style.transform = 'scaleX(1)';
          clearTimeout(to);
          setSending(false);
          success(j.id);
        })
        .catch(function () {
          clearTimeout(to);
          setSending(false);
          fail(false);
        });
    }

    var retryBtn = $('[data-w-retry]');
    if (retryBtn) retryBtn.addEventListener('click', function () { show(3, -1, true); post(); });
    $('[data-w-back-edit]').addEventListener('click', function () { show(3, -1); });

    var copyBtn = $('[data-w-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var t = $('[data-w-copy-t]');
      var done = function () {
        var old = t.textContent;
        t.textContent = T.copied;
        copyBtn.classList.add('is-ok');
        setTimeout(function () { t.textContent = old; copyBtn.classList.remove('is-ok'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(ref).then(done, function () { /* */ });
    });

    /* Neue Anfrage: Kontakt bleibt, Produkte/Budget/Fotos/Antworten werden geleert */
    function resetAll() {
      dropUndo();
      images.forEach(function (im) { URL.revokeObjectURL(im.url); });
      images = [];
      items = [];
      list.innerHTML = '';
      var it = mkItem();
      it.open = true;
      items.push(it);
      totIn.value = '';
      syncChips();
      $$('input[name="gw-cond"]').forEach(function (c) { c.checked = c.value === 'new'; });
      var any = root.querySelector('input[name="gw-dl"][value="any"]');
      if (any) any.checked = true;
      $$('input[name="gw-pay"]').forEach(function (r) { r.checked = false; });
      $('[data-w-buy]').checked = false;
      inp('message').value = '';
      ref = '';
      $$('.is-invalid').forEach(function (f) { setErr(f, ''); });
      var more = $('[data-w-more]');
      if (more) more.open = false;
      setMode('each');
      renderItems();
      paintDrops();
    }
    $('[data-w-restart]').addEventListener('click', function () {
      resetAll();
      show(1, -1);
      setTimeout(function () { items[0].$('[data-w-k="what"]').focus({ preventScroll: true }); }, 50);
    });

    /* ---------- Entwurf (nur Text, localStorage, 14 Tage) ---------- */
    var saveT = null;
    function snapshot() {
      return {
        t: Date.now(),
        items: items.map(function (it) { return { what: it.what, variant: it.variant, qty: it.qty, budget: it.budget, link: it.link }; }),
        bmode: bmode,
        total: num(totIn.value),
        cond: conds().map(function (c) { return c.value; }),
        dl: (radio('gw-dl') || {}).value,
        pay: (radio('gw-pay') || {}).value,
        name: val('name'), email: val('email'), cc: ccSel ? ccSel.value : '49', phone: val('phone'), ch: chKey(), message: val('message')
      };
    }
    function save() {
      clearTimeout(saveT);
      saveT = setTimeout(function () {
        if (step === 'ok') return;
        var d = snapshot();
        var any = d.items.some(function (x) { return x.what || x.variant || x.budget || x.link; }) || d.name || d.email || d.phone;
        if (!any) { ls(function (s) { s.removeItem(DRAFT_KEY); }); return; }
        ls(function (s) { s.setItem(DRAFT_KEY, JSON.stringify(d)); });
      }, 300);
    }
    root.addEventListener('input', save);
    root.addEventListener('change', save);

    function restore(d) {
      list.innerHTML = '';
      items = (Array.isArray(d.items) && d.items.length ? d.items : [{}]).slice(0, MAX_ITEMS).map(function (x) { return mkItem(x); });
      bmode = d.bmode === 'total' && items.length > 1 ? 'total' : 'each';
      var todo = items.filter(function (x) { return checkItem(x, false); })[0];
      if (todo || items.length === 1) (todo || items[0]).open = true;
      ['name', 'email', 'phone', 'message'].forEach(function (k) {
        var el = inp(k);
        if (el && d[k]) el.value = d[k];
      });
      if (d.cc && ccSel && ccSel.querySelector('option[value="' + d.cc + '"]')) ccSel.value = d.cc;
      if (Array.isArray(d.cond) && d.cond.length) $$('input[name="gw-cond"]').forEach(function (c) { c.checked = d.cond.indexOf(c.value) >= 0; });
      [['gw-dl', d.dl], ['gw-pay', d.pay], ['gw-ch', d.ch]].forEach(function (x) {
        var r = x[1] && root.querySelector('input[name="' + x[0] + '"][value="' + x[1] + '"]');
        if (r) r.checked = true;
      });
      if (d.total) totIn.value = nf.format(Math.min(9999999, d.total));
      if (d.message) { var more = $('[data-w-more]'); if (more) more.open = true; }
      renderItems();
      setMode(d.bmode);
      syncChips();
    }
    function readDraft() {
      var d = null;
      try { d = JSON.parse(ls(function (s) { return s.getItem(DRAFT_KEY); }) || 'null'); } catch (e) { d = null; }
      if (!d) {
        /* Entwurf aus dem alten Formular (ein Produkt) übernehmen */
        var o = null;
        try { o = JSON.parse(ls(function (s) { return s.getItem(OLD_DRAFT_KEY); }) || 'null'); } catch (e) { o = null; }
        ls(function (s) { s.removeItem(OLD_DRAFT_KEY); });
        if (o) {
          d = {
            t: o.t,
            items: [{ what: o.what, variant: o.variant, qty: o.qty, budget: o.budget, link: o.link }],
            cond: o.cond, dl: o.dl, name: o.name, email: o.email, phone: o.phone, message: o.message, ch: o.ch === 'email' ? 'email' : 'wa'
          };
        }
      }
      if (d && (!d.t || Date.now() - d.t > DRAFT_DAYS * 864e5)) { d = null; ls(function (s) { s.removeItem(DRAFT_KEY); }); }
      return d;
    }
    var draft = readDraft();
    if (draft) {
      restore(draft);
      if (draft.items && draft.items.some(function (x) { return x && x.what; })) {
        var note = document.createElement('p');
        note.className = 'gw__draft';
        note.innerHTML = '<span>' + esc(T.draft) + '</span><button type="button" class="gw__link">' + esc(T.draftClear) + '</button>';
        note.querySelector('button').addEventListener('click', function () {
          resetAll();
          ls(function (s) { s.removeItem(DRAFT_KEY); });
          note.remove();
          items[0].$('[data-w-k="what"]').focus();
        });
        panels['1'].insertBefore(note, list);
      }
    } else {
      var it0 = mkItem(+root.dataset.bdef > 0 ? { budget: +root.dataset.bdef } : null);
      it0.open = true;
      items.push(it0);
      renderItems();
    }
    syncChips();
    paintPhone();
    paintDrops();
    show(1, 0, true);

    /* ---------- Handy: Gopa-Knopf (unten rechts) weicht der klebenden Weiter-Leiste aus (wie gop-new-arrivals.js, Klasse is-shy) ---------- */
    (function shyMascot() {
      var mascot = document.querySelector('[data-gop-mascot]');
      if (!mascot || !('IntersectionObserver' in window)) return;
      var on = false;
      new IntersectionObserver(function (en) {
        var hit = en[en.length - 1].isIntersecting;
        if (hit === on) return;
        on = hit;
        mascot.classList.toggle('is-shy', hit);
      }, { rootMargin: '-80% 0px 0px 0px' }).observe(actions);
    })();

    /* ---------- Vorbefüllen: leere Karte füllen, gleiches Produkt aktualisieren, sonst neue Karte ---------- */
    function flash(el) {
      if (!el) return;
      el.classList.remove('is-prefilled');
      void el.offsetWidth;
      el.classList.add('is-prefilled');
    }
    function prefill(data, opts) {
      var d = normPrefill(data);
      if (!d) {
        /* Nachbau-Anfrage (normPrefill verwirft sie): Formular zeigen + Hinweis statt nichts zu tun */
        var raw = data && typeof data === 'object' ? (data.what || data.text || data.product || '') + ' ' + (data.variant || '') : data;
        if (isFake(raw)) {
          goTo(false);
          var f0 = openFirst();
          if (step !== 1) show(1, -1, true);
          openItem(f0);
          setErr(f0.f('what'), T.errFake);
        }
        return false;
      }
      if (step === 'ok') resetAll();
      var target = null;
      var low = (d.what || '').toLowerCase();
      if (low) items.forEach(function (x) { if (!target && x.what.toLowerCase() === low) target = x; });
      if (!target) items.forEach(function (x) { if (!target && !x.what) target = x; });
      if (!target) {
        if (items.length < MAX_ITEMS) { target = mkItem(); items.push(target); }
        else target = items[items.length - 1];
      }
      var set = function (k, v) { target[k] = v; target.$('[data-w-k="' + k + '"]').value = k === 'budget' ? nf.format(v) : v; };
      if (d.what) set('what', d.what);
      if (d.variant) set('variant', d.variant);
      if (d.link && linkOk(d.link)) { set('link', d.link); target.$('[data-w-ext]').open = true; }
      if (d.qty) set('qty', clampQty(d.qty));
      if (d.budget) set('budget', Math.min(999999, d.budget));
      items.forEach(function (x) { x.open = x === target; });
      setErr(target.f('what'), '');
      target.el.classList.remove('is-bad');
      renderItems();
      flash(target.el);
      save();
      if (step !== 1) show(1, -1, true);
      if (!opts || opts.scroll !== false) goTo(false, opts && opts.focus ? form : null);
      /* focus: true (z. B. Eingabefeld im Hero) → nach dem Scrollen ins nächste sinnvolle Feld, Tastatur bleibt offen */
      if (opts && opts.focus) {
        var nextIn = !target.variant ? target.$('[data-w-k="variant"]') : bmode === 'each' && !target.budget ? target.$('[data-w-k="budget"]') : null;
        var doFocus = function () { if (nextIn) nextIn.focus({ preventScroll: true }); };
        if (inPlace(form) || reduce) setTimeout(doFocus, 30);
        else {
          var done = false;
          var once = function () { if (done) return; done = true; window.removeEventListener('scrollend', once); doFocus(); };
          window.addEventListener('scrollend', once);
          setTimeout(once, 900);
        }
      }
      return true;
    }
    /* Zum Formular scrollen – nur wenn es nicht schon oben im Bild ist (kein Doppel-Scroll nach einem Anker-Sprung) */
    function inPlace(el) { var r = (el || section).getBoundingClientRect(); return r.top > -60 && r.top < 180; }
    function goTo(instant, el) {
      el = el || section;
      if (inPlace(el)) return;
      el.scrollIntoView({ behavior: reduce || instant ? 'auto' : 'smooth', block: 'start' });
    }
    function open() {
      goTo();
      setTimeout(function () {
        var it = openFirst();
        var f = it && it.$('[data-w-k="what"]');
        if (f && step === 1 && !f.value) f.focus({ preventScroll: true });
      }, reduce ? 50 : 650);
    }
    document.addEventListener('gop:wish-prefill', function (e) {
      var d = e.detail || {};
      prefill(d.text != null && Object.keys(d).length === 1 ? d.text : d, { focus: !!d.focus });
    });
    document.addEventListener('gop:wish-open', open);
    window.gopWish = { prefill: prefill, open: open, root: root };

    /* URL-Parameter (?wish=…) und sessionStorage aus anderen Seiten */
    var pre = null;
    var preFocus = false;
    try {
      var qs = new URLSearchParams(location.search);
      if (qs.has('wish') || qs.has('wish_variant') || qs.has('wish_budget') || qs.has('wish_link')) {
        preFocus = qs.get('wish_focus') === '1';
        pre = { what: qs.get('wish') || '', variant: qs.get('wish_variant') || '', budget: qs.get('wish_budget') || '', link: qs.get('wish_link') || '' };
        ['wish', 'wish_variant', 'wish_budget', 'wish_link', 'wish_focus'].forEach(function (k) { qs.delete(k); });
        var q = qs.toString();
        history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + '#gop-wish');
      }
    } catch (e) { pre = null; }
    var stored = ss(function (s) { var t = s.getItem(PREFILL_KEY); s.removeItem(PREFILL_KEY); return t; });
    if (!pre && stored) pre = stored;
    /* Ankunft per #gop-wish / ?wish=: nach dem Laden einmal prüfen, ob spät geladene Bereiche das Formular verschoben haben */
    if (pre || location.hash === '#gop-wish') {
      var arrive = function () {
        goTo(true, preFocus ? form : null);
        if (pre) prefill(pre, { scroll: false, focus: preFocus });
      };
      if (document.readyState === 'complete') setTimeout(arrive, 150);
      else window.addEventListener('load', function () { setTimeout(arrive, 150); });
    }
  }

  /* Knöpfe mit data-wish (3D-iPhone, Showroom, Kacheln …) auch ohne assets/gop-hub.js: Formular auf dieser Seite vorbefüllen */
  if (!window.__gopWishClicks) {
    window.__gopWishClicks = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-wish]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var t = a.getAttribute('data-wish');
      if (window.gopWish) {
        e.preventDefault();
        if (t) window.gopWish.prefill(t); else window.gopWish.open();
      } else if (t) {
        ss(function (s) { s.setItem(PREFILL_KEY, t); });
      }
    });
  }
  if (!window.gopAskWish) {
    window.gopAskWish = function (t) { if (window.gopWish) { window.gopWish.prefill(t) || window.gopWish.open(); return true; } return false; };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gop-wish]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
